import React from 'react';
import './frequent.css';

const FrequentToggler = ({ faq, index, toggleFAQ }) => {
  return (
    <div
      className={`faq ${faq.open ? 'open' : ''}`}
      key={index}
      onClick={() => toggleFAQ(index)}
    >
      <div className="faq-question">{faq.question}</div>
      <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }} />
    </div>
  );
};

export default FrequentToggler;



// import React from "react";
// import "./frequent.css";

// const FrequentToggler = ({ faq, index, toggleFAQ }) => {
//   return (
//     <div
//       className={"faq " + (faq.open ? "open" : "")}
//       key={index}
//       onClick={() => toggleFAQ(index)}
//     >
//       <div className="faq-question">{faq.question}</div>
//       <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }} />
//     </div>
//   );
// };



// export default FrequentToggler;